'use client';

import React from 'react';
import { useLivePreview } from '@payloadcms/live-preview-react';
import { Page } from '@/payload/payload-types';
import { Blocks } from '@/app/_components/Blocks';

export const LivePreviewListener: React.FC<{
  initialData: Page;
  serverURL: string;
  depth?: number;
}> = ({ initialData, serverURL, depth = 0 }) => {
  // Payload v3: Use official useLivePreview hook from @payloadcms/live-preview-react
  const { data, isLoading } = useLivePreview<Page>({
    initialData,
    serverURL,
    depth,
  });

  return (
    <React.Fragment>
      {isLoading && (
        <div style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          right: 0, 
          background: '#4f46e5', 
          color: 'white',
          padding: '10px', 
          zIndex: 9999,
          textAlign: 'center'
        }}>
          🔄 Live preview updating...
        </div>
      )}
      <Blocks blocks={data.layout} disableTopPadding={false} />
    </React.Fragment>
  );
};